import { render, staticRenderFns } from "./PromotionTable.vue?vue&type=template&id=9da56f74&scoped=true&"
import script from "./PromotionTable.vue?vue&type=script&lang=js&"
export * from "./PromotionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da56f74",
  null
  
)

export default component.exports